module.exports = __webpack_public_path__ + "static/media/sim_background.0d320649.jpg";